module.exports = __webpack_public_path__ + "images/tips/info-image-03@1x.68fe6ac4cd198b845184.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/info-image-03@1x.png
// module id = 4HJc
// module chunks = 13